import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import Styles from "../../../Styles/CommomDashboard/UserGuide.module.css";
import pdfData from "../../../assets/OTC_Manual_v1.pdf";

import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const tableHead = [
  {
    id: "1a",
    page: 3,
    name: "Sign Up/In ",
    others: [
      {
        id: "1a1",
        page: 4,
        name: "Registration Process",
      },
      {
        id: "1a2",
        page: 7,
        name: "Login Procedure",
      },
      {
        id: "1a3",
        page: 8,
        name: "Forgot Password",
      },
    ],
  },
  {
    id: "2a",
    page: 10,
    name: "Dashboard Layout",
    others: [
      {
        id: "2a1",
        page: 11,
        name: "Buy and Sell Dashboard",
      },
      {
        id: "2a2",
        page: 16,
        name: "Banking Dashboard",
      },
    ],
  },
  {
    id: "3a",
    page: 19,
    name: "Buy & Sell Listing ",
    others: [
      {
        id: "3a1",
        page: 21,
        name: "Add Listing",
      },
      {
        id: "3a2",
        page: 23,
        name: "Connect with Counterparty",
      },
      {
        id: "3a3",
        page: 29,
        name: "Close connection",
      },
    ],
  },
  {
    id: "4a",
    page: 34,
    name: "Banking",
    others: [
      {
        id: "4a1",
        page: 36,
        name: "Add Listing for Banking",
      },
      {
        id: "4a2",
        page: 38,
        name: "Connect with Counterparty",
      },
      {
        id: "4a3",
        page: 45,
        name: "Letter of Intent",
      },
      {
        id: "4a4",
        page: 48,
        name: "Agreement",
      },
      {
        id: "4a5",
        page: 50,
        name: "Banking Ledger",
      },
      {
        id: "4a6",
        page: 52,
        name: "Close Connection",
      },
      {
        id: "4a7",
        page: 54,
        name: "My Banking",
      },
    ],
  },
  {
    id: "5a",
    page: 56,
    name: "Search Banking",
  },
  {
    id: "6a",
    page: 58,
    name: "Landing Cost Calculator",
  },
  {
    id: "7a",
    page: 60,
    name: "Account Actions",
    others: [
      {
        id: "7a1",
        page: 62,
        name: "Edit profile",
      },
      {
        id: "7a2",
        page: 64,
        name: "Change Password",
      },
      {
        id: "7a3",
        page: 66,
        name: "My Document",
      },
      {
        id: "7a4",
        page: 68,
        name: "My Listing",
      },
      {
        id: "7a5",
        page: 70,
        name: "Logout",
      },
    ],
  },
  {
    id: "8a",
    page: 72,
    name: "Company Admin",
    others: [
      {
        id: "8a1",
        page: 74,
        name: "Add User",
      },
      {
        id: "8a2",
        page: 76,
        name: "Grant Permission",
      },
      {
        id: "8a3",
        page: 78,
        name: "Delete User",
      },
      {
        id: "8a4",
        page: 80,
        name: "Add Template",
      },
    ],
  },
];

const UserGuide = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    if (pageNumber === 3) {
      changePage(-2);
    } else {
      changePage(-1);
    }
  }

  function nextPage() {
    if (pageNumber === 1) {
      changePage(2);
    } else {
      changePage(1);
    }
  }

  function directPage(num) {
    setPageNumber(num);
  }

  return (
    <div className={Styles.userGuideMainPage}>
      <div className={Styles.navContainer}>
        <div className={Styles.tableHeadingCont}>
          <div className={Styles.tableHeadingText}>Table Of Content</div>
          {tableHead?.map((data1) => (
            <div style={{ marginTop: "-10px" }}>
              <div
                className={`${
                  data1?.page === pageNumber
                    ? Styles.topLevelEmelActive
                    : Styles.topLevelEmel
                }`}
                onClick={() => directPage(data1?.page)}
              >
                {data1?.name}
              </div>
              <ul>
                {data1?.others?.map((data2) => (
                  <li
                    className={`${
                      data2?.page === pageNumber
                        ? Styles.bottomElemTextActive
                        : Styles.bottomElemText
                    }`}
                    onClick={() => directPage(data2?.page)}
                  >
                    {data2?.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className={Styles.pdfContainer}>
        <div className={Styles.documentLayer}>
          <button
            type="button"
            disabled={pageNumber <= 1}
            onClick={previousPage}
            className={Styles.buttonIcons}
          >
            <ArrowBackIosNewRoundedIcon style={{ fontSize: "32px" }} />
          </button>
          <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} />
          </Document>
          <button
            type="button"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
            className={Styles.buttonIcons}
          >
            <ArrowForwardIosRoundedIcon style={{ fontSize: "32px" }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserGuide;
